module.exports = __webpack_public_path__ + "2224954528f3828ea415d8aad4cf0f3d.png";